import styled from 'styled-components';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

// CONSTANTS
import { PORCELAIN } from '@/constants/colors';

export const Wrapper = styled.div`
  .streaming-marketplace-discover,
  &.streaming-marketplace-discover {
    margin: 0 auto;
    max-width: 1440px;
    display: flex;
    ${p => `min-height: calc(100vh - ${p.theme.headerHeight}px)`};

    &--iframe {
      min-height: 400px;
    }

    &__content {
      width: 100%;
      display: flex;
      flex-direction: column;

      ${breakpoints.down('sm')} {
        padding-left: 0;
      }
    }
    &__sidebar {
      z-index: 1210;
      width: 325px;

      ${breakpoints.down('sm')} {
        min-width: auto;
        width: 0;
      }

      &-paper {
        padding: 0;
        height: 100%;
        border-top: none;
        border-bottom: none;
        overflow: auto;
      }
    }

    &__container {
      padding-top: 40px;
      padding-bottom: 40px;
      position: relative;
      height: 100%;

      &::before {
        background: ${PORCELAIN};
        content: '';
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 100%;
      }

      ${breakpoints.down('xs')} {
        padding-top: 100px;
      }

      &-controls {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 30px;
      }
    }

    .filters,
    &__filters {
      &__search {
        .MuiInputBase-root {
          font-size: 1.8rem;
          font-weight: 400;
          padding: 9px 15px;
          input {
            padding: 5px 0 5px 10px;
          }
        }
        &__icon {
          color: inherit;
          font-size: 2rem;
          margin-top: 0;
        }
      }

      &__filters-button {
        padding: 0;
        border-radius: 50%;
        min-width: 50px;
        max-width: 50px;
        height: 50px;
        font-size: 18px;
      }
    }
  }
`;

export default Wrapper;
